module.exports = "//static.hsappstatic.net/crm-pipeline-board-settings-lib/static-1.2657/images/default_illustration.svg"